// Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faMagnifyingGlass
} from "@fortawesome/free-solid-svg-icons";

// Estilos
import './SearchInputRes.css'
import {SEARCH_FILTRO} from '../../constants/colors';

/*
    Componente de boton de lupa que funciona para filtrar por busqueda en Mis Reservas.
        Donde buscar es la función que llama para filtrar por lo ingresado por el usuario.
*/
function SearchInputRes({ filter, buscar, handleOnBlur = () => {}}) {

    return (
        <div className={`search-container-res add-search-res ${filter ? 'conValor' : ''}`}>
            <FontAwesomeIcon icon={faMagnifyingGlass} className='add-search-cont-res' style={{color: SEARCH_FILTRO }} />
            <input onBlur={handleOnBlur} placeholder='Buscar por Jugador o Reservado por... puede encerrar entre comillas dobles para "coincidencia exacta"' className='input-search-txt-res' value={filter} onChange={data => buscar(data.target.value)} />
        </div>
    );
}

export default SearchInputRes
